import { cards } from '@/mocks/siteData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            独家爆料
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">一手猛料深度揭秘，还原影视圈真实面貌</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.slice(0, 6).map((card, i) => (
            <article
              key={i}
              className={`group bg-background-50 border border-background-200/60 rounded-xl overflow-hidden hover:border-primary-200 transition-all cursor-pointer ${
                i === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
              }`}
            >
              <div className="relative overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className={`w-full object-cover object-top group-hover:scale-105 transition-transform duration-500 ${
                    i === 0 ? 'h-52 md:h-64' : 'h-44 md:h-48'
                  }`}
                  title={card.title}
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs px-2.5 py-1 bg-primary-500 text-background-50 rounded-full font-medium">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors leading-snug">
                  {card.title}
                </h3>
                <p className="text-foreground-600 text-xs md:text-sm leading-relaxed line-clamp-3">{card.excerpt}</p>
                <div className="mt-3 text-xs text-foreground-400">{card.time}</div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-5">
          <article className="group bg-background-50 border border-background-200/60 rounded-xl overflow-hidden hover:border-primary-200 transition-all cursor-pointer flex flex-col md:flex-row">
            <div className="md:w-[340px] flex-shrink-0 relative overflow-hidden">
              <img
                src={cards[6].image}
                alt={cards[6].title}
                className="w-full h-48 md:h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                title={cards[6].title}
              />
              <div className="absolute top-3 left-3">
                <span className="text-xs px-2.5 py-1 bg-primary-500 text-background-50 rounded-full font-medium">
                  {cards[6].tag}
                </span>
              </div>
            </div>
            <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
              <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                {cards[6].title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed line-clamp-4">{cards[6].excerpt}</p>
              <div className="mt-3 text-xs text-foreground-400">{cards[6].time}</div>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}